import React from "react";
import "./EnterpriseContributor.scss";

const EnterpriseContributor = ({contentCreatorData}) => {

  return (
      <div className="enterprise-contributor-card-container">
        <div className="enterprise-contributor-card-box">
          <div className="enterprise-contributor-card-profile">
            <img
                src={"/images/grison.jpeg"}
                className="enterprise-contributor-card-profile-img"
                alt=""
            />
            <div className="enterprise-contributor-card-profile-info">
              <p className="enterprise-contributor-card-profile-name">{contentCreatorData.name} {contentCreatorData.lastName}</p>
              <p className="enterprise-contributor-card-profile-profession">{contentCreatorData.contentCreatorAccount.profession}</p>
              <p className="enterprise-contributor-card-profile-channel">{contentCreatorData.contentCreatorAccount.channelUrl}</p>
            </div>
          </div>
        </div>
      </div>
  )
}

export default EnterpriseContributor;